import { TvStatus } from '@tmdb-graphql-api/schema/types';
import { isFuture } from 'date-fns';
import { startCase } from 'lodash-es';
import { tt } from '#i18n/index.ts';

export const formatAirDates = (firstAirDate: string, lastAirDate: string | null | undefined, status: string) => {
  if (!firstAirDate) {
    return startCase(status.toLowerCase());
  }

  const firstAirDateObj = new Date(firstAirDate);

  if ((status === TvStatus.Ended.toString() || status === TvStatus.Canceled.toString()) && lastAirDate) {
    const firstAirDateYear = firstAirDateObj.getFullYear();
    const lastAirDateYear = new Date(lastAirDate).getFullYear();

    return firstAirDateYear === lastAirDateYear
      ? firstAirDateYear
      : `${String(firstAirDateYear)} - ${String(lastAirDateYear)}`;
  }

  if (isFuture(firstAirDateObj)) {
    return firstAirDateObj.getFullYear();
  }

  return `${String(firstAirDateObj.getFullYear())} - ${tt('watchlist.releaseDates.present')}`;
};
